import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Target, Users, TrendingUp, Shield } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="font-manrope font-bold text-4xl sm:text-5xl text-white mb-6" data-testid="about-title">
              About <span className="text-[#C5A059]">Digital Gold Gang</span>
            </h1>
            <p className="text-gray-300 text-lg leading-relaxed">
              A Web3-native financial intelligence platform built for the new generation of investors.
            </p>
          </div>

          {/* Main Content */}
          <div className="prose prose-invert max-w-none">
            <div className="bg-[#111111] border border-white/10 rounded-lg p-8 mb-8">
              <p className="text-gray-300 text-base leading-relaxed mb-4">
                Digital Gold Gang is a Web3-native financial intelligence platform built for the new generation of investors.
              </p>
              <p className="text-gray-300 text-base leading-relaxed mb-4">
                We bridge macro economics, blockchain transparency, and community-driven analysis to help individuals
                prepare for the next era of finance.
              </p>
              <p className="font-manrope font-semibold text-xl text-[#C5A059] text-center mt-8">
                Educate. Analyze. Prepare. Execute.
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
              <div className="bg-[#111111] border border-white/10 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#C5A059]/20 rounded-sm flex items-center justify-center mb-4">
                  <Target className="text-[#C5A059]" size={24} />
                </div>
                <h3 className="font-manrope font-semibold text-white text-lg mb-2">Our Mission</h3>
                <p className="text-gray-400 text-sm">
                  Empower individuals with the knowledge and tools to navigate the evolving financial landscape with confidence.
                </p>
              </div>

              <div className="bg-[#111111] border border-white/10 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#007AFF]/20 rounded-sm flex items-center justify-center mb-4">
                  <Users className="text-[#007AFF]" size={24} />
                </div>
                <h3 className="font-manrope font-semibold text-white text-lg mb-2">Community First</h3>
                <p className="text-gray-400 text-sm">
                  Built by investors, for investors. We believe in collective intelligence and open knowledge sharing.
                </p>
              </div>

              <div className="bg-[#111111] border border-white/10 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#C5A059]/20 rounded-sm flex items-center justify-center mb-4">
                  <TrendingUp className="text-[#C5A059]" size={24} />
                </div>
                <h3 className="font-manrope font-semibold text-white text-lg mb-2">Data-Driven</h3>
                <p className="text-gray-400 text-sm">
                  From on-chain metrics to macro indicators, we focus on actionable insights backed by real data.
                </p>
              </div>

              <div className="bg-[#111111] border border-white/10 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#007AFF]/20 rounded-sm flex items-center justify-center mb-4">
                  <Shield className="text-[#007AFF]" size={24} />
                </div>
                <h3 className="font-manrope font-semibold text-white text-lg mb-2">Education Focus</h3>
                <p className="text-gray-400 text-sm">
                  We prioritize learning over speculation. Understanding fundamentals is the foundation of smart investing.
                </p>
              </div>
            </div>

            {/* Powered By */}
            <div className="mt-12 text-center">
              <p className="text-gray-500 text-sm">
                Powered by <span className="text-[#C5A059] font-semibold">Emergent Labs</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;
